import React from "react";
import { ButtonEdit } from "src/components/Common/Button";
import DatePickerCustomField from "src/components/Common/Form/DatePickerCustomField";
import ProtectedComponent from "src/components/Permission";
import classNames from "classnames";

const EditableDateField = ({
  label,
  fieldName,
  value,
  setValue,
  control,
  errors,
  placeholder = "YYYY/MM/DD",
  classGroup = "mb-0 width-by-px-200",
  minDate = null,
  maxDate = null,
  dateFormat = "yyyy/MM/dd",
  className = "",
  disabled = false,
  tooltipText = "edit",
  translation = "test-package",
}) => {
  const [isEditingState, setIsEditingState] = React.useState(false);

  const convertDateToSlashes = (dateString) => {
    if (!dateString) return "";
    return dateString.replace(/-/g, "/");
  };

  return (
    <div className={classNames("row mb-1 align-items-center", className)}>
      <div className="col-md-3 p-y-8">
        <label className="form-label mb-0 position-relative">{label}:</label>
      </div>
      <div className="col-md-9 p-y-8">
        <div className="d-flex align-items-center gap-1">
          <div className={`${isEditingState ? "d-block" : "d-none"}`}>
            <DatePickerCustomField
              name={fieldName}
              placeholder={placeholder}
              control={control}
              errors={errors}
              defaultValue={value}
              classGroup={classGroup}
              minDate={minDate}
              maxDate={maxDate}
              dateFormat={dateFormat}
            />
          </div>
          {isEditingState && (
            <button
              className="btn btn-blank text-dark p-1"
              onClick={() => {
                setValue(fieldName, value || "");
                setIsEditingState(false);
              }}
            >
              <i className="bi bi-x-lg" />
            </button>
          )}
          <div className={`d-flex align-items-center ${isEditingState ? "d-none" : "d-flex"}`}>
            {value && <p className="mb-0 me-2">{convertDateToSlashes(value)}</p>}
            <ProtectedComponent id={`test_package_edit_date_${fieldName}`}>
              <ButtonEdit
                isShow={!isEditingState}
                handleClick={() => setIsEditingState(true)}
                id={fieldName}
                disabled={disabled}
                tooltipText={tooltipText}
                translation={translation}
              />
            </ProtectedComponent>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditableDateField;
